import {
  getAnalogsProduct,
  getAnalogsProductInitData,
  getAnaloguesByProductData,
  getProductBrand,
  getProductSpecs,
  productActions,
  TabTitle,
  getProductModel,
} from '@entities/Product';
import { useWindowSizing } from '@hooks/useSizeWindow';
import { useAppDispatch, useAppSelector } from '@redux/hooks';
import { FC, useEffect } from 'react';
import { DesktopTable } from './Desktop';
import { ListProduct } from './Mobile';
import { AnaloguesProductTypeProps } from './TypeProps';
import { selectRegion } from '@redux/slices/header';
import { TitleBlock } from '../TitleBlock';
import { MyLink } from '@app/shared';
import { ProductSpecCode } from '@entities/Product/module/types/productSchema';
import config from '@app/config';
import classNames from 'classnames';

import styles from './AnaloguesProduct.module.scss';

const AnaloguesProduct: FC<AnaloguesProductTypeProps> = ({ className, productId }) => {
  const dispatch = useAppDispatch();
  const { REGION: regionId } = useAppSelector(selectRegion);
  const isMobile = useWindowSizing(768);
  const isInitData = useAppSelector(getAnalogsProductInitData);
  const brand = useAppSelector(getProductBrand);
  const model = useAppSelector(getProductModel);
  const listAnalogsProduct = useAppSelector(getAnalogsProduct);
  const specs = useAppSelector(getProductSpecs);
  const size = specs.find(x => x.code === ProductSpecCode.Size);

  useEffect(() => {
    if (!isInitData && config.safeModeAnaloguesByCartProduct !== 'true') {
      dispatch(getAnaloguesByProductData({ productId, regionId: parseInt(regionId) }));
    }
  }, []);

  useEffect(() => {
    if (isInitData && !listAnalogsProduct.length) {
      dispatch(productActions.hideTab([TabTitle.Analogues]));
    }
  }, [isInitData]);

  if (!listAnalogsProduct?.length) {
    return null;
  }

  return (
    <div className={classNames(styles.WrapperAnaloguesProduct, className)}>
      <TitleBlock className={styles.Title}>
        {isMobile ? 'Аналоги' : `Шины в размере ${size?.value}, похожие на ${brand?.name} ${model?.name}`}
      </TitleBlock>
      {isMobile ? <ListProduct /> : <DesktopTable />}
      {size && size.href && (
        <div className={styles.LinkSize}>
          <MyLink href={size.href}>Все шины в размере {`${size.meta?.width} ${size.meta?.height} R${size.meta?.diameter}`}</MyLink>
        </div>
      )}
    </div>
  );
};

export default AnaloguesProduct;
